import { z } from 'zod';

export const TipoResumoSchema = z.enum(['RESUMO', 'ATA', 'RESPOSTA']);
export type TipoResumo = z.infer<typeof TipoResumoSchema>;

export const CriarResumoSchema = z.object({
  tipo: z.enum(['RESUMO', 'ATA']),
});
export type CriarResumo = z.infer<typeof CriarResumoSchema>;

export const PerguntaSchema = z.object({
  pergunta: z.string().min(3).max(2000),
});
export type Pergunta = z.infer<typeof PerguntaSchema>;

export const ResumoSchema = z.object({
  id: z.string(),
  gravacaoId: z.string(),
  tipo: TipoResumoSchema,
  pergunta: z.string().nullable(),
  conteudoMd: z.string(),
  modelo: z.string(),
  criadoEm: z.iso.datetime(),
});
export type Resumo = z.infer<typeof ResumoSchema>;
